export const sortActionTypes = {
    
    SET_SORT_MODE: 'SET_SORT_MODE'

}
